import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=74bee25e&scoped=true&"
import script from "./Photos.vue?vue&type=script&lang=js&"
export * from "./Photos.vue?vue&type=script&lang=js&"
import style0 from "./Photos.vue?vue&type=style&index=0&id=74bee25e&scoped=true&lang=css&"
import style1 from "./Photos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bee25e",
  null
  
)

export default component.exports